<template>
    <div class="camara">
        <video autoplay class="feed"></video>
        <button  class="snap" v-on:click="$emit('takePicture')">SNAP</button>
    </div>
</template>

<script>
    export default{
        name: 'Camara',
        methods:{
            takePicture(){
                console.log("Take Picture");
            },
            init: function (){
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    let constraints = {
                            video: {
                                width: {
                                    min: 640,
                                    ideal: 1280,
                                    max: 1920
                                },
                                height: {
                                    min: 360,
                                    ideal: 720,
                                    max: 1080
                                }
                            }
                        };
                    navigator.mediaDevices.getUserMedia(constraints).then(stream => {                      
                        const videoPlayer = document.querySelector("video");
                        videoPlayer.srcObject = stream;
                        videoPlayer.play();
                    });
                } else {
                    alert("Cannot get Media Divices");
                }
            }
        },
        beforeMount (){
            this.init();
        }
    }
</script>

<style lang="scss" scoped>
    .camara {
        width: 45vw;
        height: 57vh;
        padding: 25px;
        box-sizing: border-box;

        .feed {
            display: block;
            width: 70%;
            max-width: 1280px;
            margin: 0 auto;
            background-color: #171717;
            box-shadow: 6px 6px 12px 0px rgba(0,0,0,0.35);
        }

        .snap {
            display: block;
            width: 75px;
            height: 75px; 
            border-radius: 50%;

            margin: 25px auto;

            background-color: transparentize($color: #FFCE00, $amount: 0.5);
            border: 1px solid #171717;
            outline: none;

            &:hover {
                background-color: #FFCE00;
            }
            &:active {
                background-color: darken($color: #FFCE00, $amount: 10);
            }
        }
    }
</style>